
<div class="innerpage-fullwithbanner dashboardarea clearfix">
    <div class="left">
        <h2 class="bighead">1031 Trade</h2>
        <ul class="bread-crumbs">
            <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
            <li>1031 Trade</li>
        </ul>
    </div>
    <div class="right">

        <a class="linksdashboard brokericon" placement="left" tooltip="Associated Brokers"><span class="icon-manager icon"></span></a>
        <a class="linksdashboard" placement="left" tooltip="Invite Principal"><span class="icon-users icon"></span></a>

    </div>
    <div class="clearfix"></div>
</div>
<div class="clearfix"></div>
<div class="tabstyle2 dashboardtab " style="background:#fff;">
    <ul class="switchingproperty">
        <li [class.active]="1==1">
            <a href="javascript:void(0);">
                1031 Trade Dashboard
            </a>
        </li>
        <li>
            <a href="javascript:void(0);">
                Pipeline
            </a>
        </li>
        <li>
            <a href="javascript:void(0);">
                Deals
            </a>
        </li>
        <li>
            <a href="javascript:void(0);">
                Exchanges
            </a>
        </li>
    </ul>
    <div class="successstep container min-heightcontainer margin-bottom-0">
        <img src="/assets/img/settings.png" class="centerimg"/>
        <h4>Hi {{LoggedInUser.FirstName + ' '+ LoggedInUser.LastName}}, We are setting up your 1031 exchange.</h4>
        <h6>For assistance please contact your B+E Broker.</h6>
        <br/>
        <div *ngIf="ExchangeInvitesList">
           
            <div class="initial-dashboard custom_no_dashboard" style="padding-top:0;">
                <ul class="connection-list brokerlist" style="max-width:none !important;">
                    <li class="clearfix">
                        <img [src]="ExchangeInvitesList.PhotoPath !=='' ? ExchangeInvitesList.PhotoPath  :'/../../../assets/img/default-profile-img.png'" />
                        <div class="right">
                            <h6>
                                {{ExchangeInvitesList.Name}}
                            </h6>
                            <p>
                                <i class="icon-phone icon"></i> {{ExchangeInvitesList.Phone|phone}}
                            </p>
                            <p >
                                <i class="icon-message icon"></i> {{ExchangeInvitesList.Email}}
                            </p>
                        </div>
                    </li>
                </ul>
                <div class="clearfix"></div>
            </div>
           
        </div>
    </div>
</div>